import { Injectable } from '@angular/core';
import { Country } from 'app/models/Country';
import { handleErrors } from 'app/common/error';
import { TranslateService } from '@ngx-translate/core';
import { CountryService } from '../../country/country.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class CountryListService {
  constructor(
    private countryService: CountryService,
    private translateService: TranslateService,
    private toastr: ToastrService
  ) {}

  isCountryUSA(countryId?: number): Observable<boolean> {
    return this.countryService.getCountries().pipe(
      map((countries) => {
        if (countryId === null) {
          return true;
        }
        for (const country of countries) {
          if (country.countryId === countryId) {
            return country.isInUS;
          }
        }
      }),
      catchError((error) => {
        handleErrors(
          error,
          this.translateService,
          this.toastr,
          'SurveyCommon-COUNTRY_LIST_NOT_AVAILABLE'
        );
        return of('error', error);
      })
    );
  }
}
